export default __webpack_public_path__ + "static/media/Hero-image.3d0d407b.png";